import React from 'react';
import { store as notificationStore } from 'react-notifications-component';

const animationDefaultTime = 2500;

export const dangerNotification = (
  title: string,
  message: string,
  durationMs: number = animationDefaultTime,
  yDirection = 'bottom'
) => {
  notificationStore.addNotification({
    title,
    message,
    type: 'danger',
    insert: yDirection,
    container: `${yDirection}-right`,
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: durationMs
    }
  });
};

/**
 * Notificação de validação que pode levar o usuário até o campo com erro.
 * O componente de notificação suporta conteúdo customizado, o que permite
 * manter o comportamento de clique sem alterar as notificações existentes.
 */
export const dangerNotificationWithAction = (
  title: string,
  message: string,
  onClick: () => void,
  durationMs: number = animationDefaultTime,
  yDirection = 'bottom'
) => {
  const content = React.createElement(
    'div',
    {
      onClick,
      role: 'button',
      tabIndex: 0,
      style: {
        backgroundColor: '#dc3545',
        borderLeft: '8px solid #bd1120',
        borderRadius: '3px',
        color: '#fff',
        cursor: 'pointer',
        padding: '8px 15px',
        width: '100%'
      },
      onKeyDown: (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClick();
        }
      }
    },
    React.createElement(
      'div',
      { style: { fontSize: '14px', fontWeight: 700, marginBottom: '5px' } },
      title
    ),
    React.createElement(
      'div',
      { style: { fontSize: '14px', lineHeight: '150%' } },
      message
    )
  );

  notificationStore.addNotification({
    content,
    type: 'danger',
    insert: yDirection,
    container: `${yDirection}-right`,
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: durationMs,
      click: true
    }
  });
};

export const successNotification = (
  title: string,
  message: string,
  yDirection = 'bottom',
  durationMs: number = animationDefaultTime
) => {
  notificationStore.addNotification({
    title: title,
    message: message,
    type: 'success',
    insert: yDirection,
    container: `${yDirection}-right`,
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    durationMs,
    dismiss: {
      duration: durationMs || animationDefaultTime
    },
    width: 300
  });
};

export const warningNotification = (
  title: string,
  message: string,
  yDirection = 'bottom',
  duration?: number
) => {
  notificationStore.addNotification({
    title: title,
    message: message,
    type: 'warning',
    insert: yDirection,
    container: `${yDirection}-right`,
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: duration || 30000
    },
    width: 300
  });
};
